import { createContext, useContext } from "react";
const context = createContext(void 0);
context.displayName = "CookbookContext";
const CookbookContextProvider = context.Provider;
const useCookbookContext = () => useContext(context);
const cookbookReactContext = context;
export {
  CookbookContextProvider,
  context,
  cookbookReactContext,
  useCookbookContext
};
//# sourceMappingURL=index.js.map
